import { IEditorV3 } from "@azu-business/editor-v3";
import { ArsBlock } from "aic";
import { v3EditorProps } from "components/common/v3EditorProps";
import { useAppSettings, useTlfContext } from "contexts/AppSettingsContext";
import { UPDATE_TLF } from "contexts/tlf/interface";
import { eTlfItemType } from "functions/api/enums";
import { isTlfItemReadDto } from "functions/api/tlfItem/TlfItemReadDto";
import { ReactElement } from "react";
import { Col, Row } from "react-bootstrap";

const dropText: IEditorV3 = {
  lines: [
    {
      textBlocks: [
        {
          text: "Drop grouping factors here",
          style: "OptionalLocked",
          type: "text",
        },
      ],
    },
  ],
};

/**
 * ARS-specific PageBy editor that stores grouping factor data on the TLF item.
 *
 * @returns ARS PageBy editor or null outside ARS items
 */
export const ArsPageBy = (): ReactElement | null => {
  const appSettings = useAppSettings();
  const tlfContext = useTlfContext();
  const tlfData = tlfContext.tlfData;

  if (
    !tlfContext ||
    !isTlfItemReadDto(tlfData) ||
    (tlfData.type !== eTlfItemType.arsListing && tlfData.type !== eTlfItemType.arsTable)
  )
    return null;

  return (
    <Row className="my-4">
      <Col>
        <ArsBlock
          disabled={tlfContext.readOnly}
          dropText={dropText}
          editorDefns={v3EditorProps}
          id={`ars-page-by-${tlfData.id}`}
          setValue={(pageBy) =>
            tlfContext.dispatch({
              operation: UPDATE_TLF,
              tlfData: { pageBy },
              calledFrom: "ArsPageBy onChange",
            })
          }
          style={appSettings.defaultTableStyle}
          value={tlfData.pageBy}
        />
      </Col>
    </Row>
  );
};

ArsPageBy.displayName = "ArsPageBy";
